const accordion = [
  {
    id: 1,
    title: 'Vision',
    quote: 'What does Success LOOK and FEEL like ',
    info:
      'Sharing is creating. Listening and Clearly defining the vision is the first step on the path of success.',
  },
  {
    id: 2,
    title: 'Honesty',
    quote: 'Build, Break, Learn',
    info:
      'Somethings might seem nice to have. Somethings might seem valuable to have. There is only one way to know for sure and it starts with finishing. Building iterations of your vision and opening the vision to others for feedback will bring honesty to the vision.',
  },
  {
    id: 3,
    title: 'Growth',
    quote: 'A seed does not yet understand what it takes to be a tree',
    info:
      'Nurture the vision, expose it to the elements, support it through the difficult times and you will be amazed with what is growing in front of you.',
  },
];
export default accordion;
